
import BaseModel from './BaseModel';

const normalizeOperatingHours = (operatingHours = []) => (
    (operatingHours || []).map(item => ({
        startTime: item?.startTime || undefined,
        endTime: item?.endTime || undefined,
        isActive: item?.isActive !== undefined ? item.isActive : true,
        timeZoneOffset: item?.timeZoneOffset || '-7',
    }))
);

export default class Rates extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.hotelId = data.hotelId || undefined;
        this.mappingId = `${data.hotelId || ''}:${data.code || ''}` || undefined;
        this.name = this.translate.name || undefined;
        this.description = this.translate.description || undefined;
        this.promotionalDescription = this.translate.hasOwnProperty('promotionalDescription') ? this.translate.promotionalDescription : data.promotionalDescription || undefined;
        this.termsDescription = this.translate.hasOwnProperty('termsDescription') ? this.translate.termsDescription : data.termsDescription || undefined;
        this.shortDescription = this.translate.shortDescription || undefined;
        this.promotions = data.promotions || [];
        this.operatingHours = normalizeOperatingHours(data.operatingHours);
        this.cancelPolicy = this.translate.cancelPolicy || undefined;
        this.code = data.code || undefined;
        this.refId = data.refId || undefined;
        this.order = this.order || 0;
        this.isDefault = data.isDefault || false;
        this.isActive = data.isActive || false;
        this.dc = data.dc || [];
        this.status = data.status || false;
        this.usageStatus = data.usageStatus || false;
        this.isExtend = data.isExtend || false;
        this.isIndependent = this.translate.isIndependent || false;
    }

    export(hasTranslate = false) {
        const operatingHours = normalizeOperatingHours(this.operatingHours);
        const result = super.export({
            id: this.id,
            hotelId : this.hotelId,
            name: this.name,
            description: this.description,
            promotionalDescription: this.promotionalDescription,
            termsDescription: this.termsDescription,
            shortDescription: this.shortDescription,
            promotions: this.promotions,
            operatingHours,
            cancelPolicy: this.cancelPolicy,
            code: this.code,
            refId: this.refId,
            order: this.order,
            isActive: this.isActive,
            isDefault: this.isDefault,
            usageStatus: this.usageStatus,
            isExtend: this.isExtend,
            isIndependent: this.isIndependent
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                ratePlanId: this.translate.ratePlanId || this.id,
                name: this.name,
                description: this.description,
                promotionalDescription: this.promotionalDescription,
                termsDescription: this.termsDescription,
                order: this.order,
                shortDescription: this.shortDescription,
                cancelPolicy: this.cancelPolicy,
                operatingHours,
                isActive: this.isActive,
                languageCode: this.languageCode,
                usageStatus: this.usageStatus,
                isExtend: this.isExtend,
                isIndependent: this.isIndependent,
                status: this.status,
            }
        }
        return result;
    }
}

export class RateSync extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.code = data.code || undefined;
        this.name = data.name || undefined;
        this.description = data.description || undefined;
        this.dc = data.dc || [];
    }
}
